import bankPayment from "@/assets/articles/bank-payment-branded.webp";
import mobileWallet from "@/assets/articles/mobile-wallet-branded.webp";
import prepaid from "@/assets/articles/prepaid-branded.webp";
import testing from "@/assets/articles/testing-branded.webp";

export const ARTICLE_IMAGES = { bankPayment, mobileWallet, prepaid, testing };

/** Redactioneel gekozen hoofdbeeld per betaalmethode. */
export const METHOD_IMAGE: Record<string, { src: string; alt: string }> = {
  ideal: { src: bankPayment, alt: "Illustratie van een iDEAL-betaling via bank-app en laptop" },
  trustly: { src: bankPayment, alt: "Illustratie van een directe bankbetaling met Trustly" },
  sofort: { src: bankPayment, alt: "Illustratie van een bankoverschrijving via Sofort" },
  hipay: { src: bankPayment, alt: "Illustratie van een betaling via de HiPay-betaalpagina" },
  "apple-pay": { src: mobileWallet, alt: "Illustratie van een mobiele walletbetaling met Apple Pay" },
  "google-pay": { src: mobileWallet, alt: "Illustratie van een mobiele walletbetaling met Google Pay" },
  paysafecard: { src: prepaid, alt: "Illustratie van een prepaid voucher met budgetcontrole" },
  paypal: { src: mobileWallet, alt: "Illustratie van een PayPal-betaling vanaf een telefoon" },
  skrill: { src: mobileWallet, alt: "Illustratie van een e-walletbetaling met Skrill" },
  neteller: { src: mobileWallet, alt: "Illustratie van een e-walletbetaling met Neteller" },
  visa: { src: mobileWallet, alt: "Illustratie van een kaartbetaling met een Visa-kaart in een casinokassa" },
  mastercard: { src: mobileWallet, alt: "Illustratie van een kaartbetaling met Mastercard in een casinokassa" },
  creditcard: { src: mobileWallet, alt: "Illustratie van een creditcardbetaling in een online casinokassa" },
  revolut: { src: mobileWallet, alt: "Illustratie van een betaling vanaf een Revolut-rekening op mobiel" },
  klarna: { src: bankPayment, alt: "Illustratie van een casinostorting die in de Klarna-app wordt bevestigd" },
  muchbetter: { src: mobileWallet, alt: "Illustratie van een walletbetaling met MuchBetter op een telefoon" },
  neosurf: { src: prepaid, alt: "Illustratie van een Neosurf-voucher met code voor een casinostorting" },
  telefoonrekening: { src: mobileWallet, alt: "Illustratie van een casinostorting via de telefoonrekening met sms-bevestiging" },
};

export const TEST_IMAGE = { src: testing, alt: "Illustratie van ons testdashboard voor betaalsnelheden" };
